import {
  AttributeDataType,
  AttributeDefinition
} from "@wingspanhq/wingspan-api-sdk";
import * as Yup from "yup";

import { validatorStringGeneric } from "../../../../shared/validators/validatorStringGeneric";

function getFieldValidaitonSchema(definition: AttributeDefinition) {
  let baseValidator;
  switch (definition.type) {
    case AttributeDataType.BOOLEAN:
      baseValidator = Yup.boolean();
      break;

    case AttributeDataType.NUMBER:
      baseValidator = Yup.number().nullable();

      if (definition.validationRules?.minimum !== undefined) {
        baseValidator = baseValidator.min(
          definition.validationRules.minimum,
          `Minimum value is ${definition.validationRules.minimum}`
        );
      }

      if (definition.validationRules?.maximum !== undefined) {
        baseValidator = baseValidator.max(
          definition.validationRules.maximum,
          `Maximum value is ${definition.validationRules.maximum}`
        );
      }
      break;

    case AttributeDataType.DATETIME:
      baseValidator = Yup.date().nullable();
      break;

    case AttributeDataType.STRING:
    default:
      baseValidator = validatorStringGeneric.nullable();

      if (definition.validationRules?.regex) {
        baseValidator = baseValidator.matches(
          new RegExp(definition.validationRules?.regex),
          "Not valid"
        );
      }
  }

  if (definition.isRequired) {
    return baseValidator.required("Required");
  }

  return baseValidator;
}

export function getAttributeValidators(
  attributeDefinitions: AttributeDefinition[]
) {
  return attributeDefinitions.reduce(
    (acc, definition) => ({
      ...acc,
      [definition.key]: getFieldValidaitonSchema(definition)
    }),
    {}
  );
}
